// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero_hero__II0ju","content":"hero_content__t2_Ll"};